import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import DomainsTable from "../Domains/DomainsTable";

const DomainsListModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	const handleDomainsChanged = () => {
		props.onDomainsChanged();
	};
	
	return (
		<Dialog
			open={props.open? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
		>
			<DialogTitle id="alert-dialog-title">
				Company Domains
			</DialogTitle>
			<DialogContent>
				<DomainsTable
					onDomainsChanged={handleDomainsChanged}
				/>
			</DialogContent>
		</Dialog>
	);

}

export default DomainsListModal;